riot = require('riot')
window.riot = riot

$ = jQuery = window.jQuery = window.$ = require "jquery"

window.Isotope = Isotope = require 'isotope-layout'
window.imagesLoaded = imagesLoaded = require 'imagesloaded'

require 'intersection-observer'

require 'riot-kit/lib/gmap'
require './tags/navigation.tag'
require './tags/suppliers-quote.tag'
require './tags/client-quote.tag'
require './tags/gdpr.tag'
require './tags/tags_input.tag'
require './tags/blogselector.tag'
require './tags/video-popup.tag'
require 'riot-kit/lib/dropdown'
require 'riot-kit/lib/raw'
require 'riot-kit/lib/form'
require 'riot-kit/lib/modal'
require 'riot-kit/lib/slideshow'
require 'riot-onscroll'

mapstyle = [{ "featureType": "administrative", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "hue": "#ffb300" }, { "saturation": "32" }, { "lightness": "0" }] }, { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "hue": "#ffb800" }, { "saturation": "54" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }, { "visibility": "on" }] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "hue": "#ffb800" }, { "saturation": "29" }, { "lightness": "64" }, { "gamma": "1" }] }, { "featureType": "road", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffda7b" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#ffda7b" }] }, { "featureType": "road.highway", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffda7b" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "transit", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "saturation": "-60" }, { "color": "#d5cdb6" }] }]

riot.mount('*',{mapstyle:mapstyle})

# intersection observer
ithreshold = 0.001
window.observerCallback = (entries, observer) ->
  i = 0
  while i < entries.length
    entry = entries[i]
    # console.log entry.intersectionRatio
    if entry.intersectionRatio > ithreshold
      entry.target.className = entry.target.className.replace(RegExp(/ ?enter ?/), '') + ' enter'
      observer.unobserve entry.target
    i++
  return

options = threshold: ithreshold
observer = new IntersectionObserver(observerCallback, options)
targets = document.querySelectorAll('.intersect')
t = 0
if !document.querySelector('body').className.match(/editing/)
  while t < targets.length
    observer.observe targets[t]
    t++


# video
video = document.querySelector('.videocol iframe')
if video
  playbutton = document.querySelector('.videocol .hoverstate')
  overlay = document.querySelector('.videocol .overlay')
  # console.log "video",playbutton
  player = new Vimeo.Player(video)
  playbutton.addEventListener 'click',(e)->
    # console.log "play the video"
    overlay.classList.add('fadeout')
    setTimeout =>
      player.play()
    ,500



document.addEventListener 'duocms:updated',->
  radios4 = document.querySelectorAll('.btn-pftags')
  if radios4.length
    selectedrads = []
    [].forEach.call radios4, (rad)=>
      rad.addEventListener 'mouseup', (e)=>
        txt = document.querySelector('#portfoliotagshidden').value
        str = ","+rad.children[0].value
        if rad.className.indexOf("active")>-1
          rad.classList.remove('active')
          txt = txt.replace(str,'')
          selectedrads.splice(rad,1)
        else
          rad.classList.add('active')
          selectedrads.push(rad)
          txt = txt+str
        if selectedrads.length==0
          radios4[0].className = radios4[0].className.replace(/ ?active ?/,'')+ 'active'
        else
          radios4[0].className = radios4[0].className.replace(/ ?active ?/,' ')
        txt = txt.replace(/,,+/g,',')
        txt = txt.replace(/,$/,'')
        document.querySelector('#portfoliotagshidden').value = txt

  # # come back to this....
  # radios_svc = document.querySelectorAll('.btn-svctags')
  # if radios_svc.length
  #   selectedsvcrads = []
  #   [].forEach.call radios_svc, (radsvc)=>
  #     radsvc.addEventListener 'mouseup', (e)=>
  #       txt = document.querySelector('#servicetagshidden').value
  #       str = ","+radsvc.children[0].value
  #       if radsvc.className.indexOf("active")>-1
  #         radsvc.classList.remove('active')
  #         txt = txt.replace(str,'')
  #         selectedsvcrads.splice(radsvc,1)
  #       else
  #         radsvc.classList.add('active')
  #         selectedsvcrads.push(radsvc)
  #         txt = txt+str
  #       if selectedsvcrads.length==0
  #         radios_svc[0].className = radios_svc[0].className.replace(/ ?active ?/,'')+ 'active'
  #       else
  #         radios_svc[0].className = radios_svc[0].className.replace(/ ?active ?/,' ')
  #       txt = txt.replace(/,,+/g,',')
  #       txt = txt.replace(/,$/,'')
  #       document.querySelector('#servicetagshidden').value = txt

$(document).ready ->
  if $('.dl_portfolio').length

    iso = new Isotope '.dl_portfolio',{
      itemSelector: '.box'
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer'
      }
    }
    imgLoad = imagesLoaded($('.dl_portfolio'))
    imgLoad.on 'progress',->
      iso.layout()
    imgLoad.on 'always',->
      port = document.querySelectorAll('.dl_portfolio')
      [].forEach.call port,(p)->
        p.className = p.className.replace(/ ?loaded ?/,' ')+' loaded '
          
    # filter items on button click
    $('.portfilters').on 'click', '.filterbutton', ->
      $('.filterbutton').removeClass('active')
      $(this).addClass('active')
      filterValue = $(this).attr('data-filter')
      iso.arrange filter: filterValue
      return
    return
    
